import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { ExtraConfig } from '@gov-nx/core/app/extra-config/context.types';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const NotificationPage = lazy(() =>
	import('./NotificationPage').then(({ NotificationPage }) => ({
		default: NotificationPage,
	}))
);

export const getNotificationRoutes = (
	extraConfig: ExtraConfig['notificationRoutes']
): RouteObject[] =>
	extraConfig.notificationsConfig.enabled
		? [
				{
					path: getPagePartSlug('upozorneni'),
					element: (
						<AuthorizedRoute>
							<NotificationPage />
						</AuthorizedRoute>
					),
				},
			]
		: [];
